import http from '@core/fetch'
export default {
  //获取客服列表
  getListApi: body =>
    http('/p/wedding/index.php/Admin/APIMerchantSupport/index', { body }),

  //修改客服
  modifyApi: body =>
    http.put('/p/wedding/index.php/Admin/APIMerchantSupport/update', {
      body,
      dataType: 'json',
      onError() {}
    }),

  //删除客服
  deleteApi: body =>
    http.delete(`/p/wedding/index.php/Admin/APIMerchantSupport/del?id=${body}`),

  //添加客服
  addApi: body =>
    http.post('/p/wedding/index.php/Admin/APIMerchantSupport/add', {
      body,
      onError() {}
    }),

  checkMsgCode: body =>
    http.put('/p/wedding/index.php/Admin/APIMerchantSupport/verifySafety', {
      body
    })
}
